export const statusFilterOptions = [
	{ value: 'all', label: 'Todas' },
	{ value: '3', label: 'Acertei' },
	{ value: '4', label: 'Errei' },
	{ value: '1', label: 'Resolvidas' },
	{ value: '2', label: 'Não resolvidas' },
]

export const commentFilterOptions = [
	{ value: 'all', label: 'Todos' },
	{ value: '1', label: 'Meus comentários' },
	{ value: '2', label: 'Minhas anotações' },
]

export const modeFilterOptions = [
	{ value: 'random', label: 'Aleatório' },
	{ value: 'order', label: 'Ordenado' },
]

export const readingModeOptions = [
	{ value: 1, label: 'Modo scroll' },
	{ value: 2, label: 'Modo foco' },
]

export const questionsSolveOptions = [
	{ value: '100', label: 'Questões a resolver:  100' },
	{ value: '75', label: 'Questões a resolver:  75' },
	{ value: '50', label: 'Questões a resolver:  50' },
	{ value: '25', label: 'Questões a resolver:  25' },
]
